import { render, staticRenderFns } from "./perreg.vue?vue&type=template&id=f3675548"
import script from "./perreg.vue?vue&type=script&lang=js"
export * from "./perreg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports